define([
	"dojo/_base/declare",
	"csi/image/LightGalleryController",
	"csi/model/image",
], function(declare, LightGalleryController, {getIndexOfKeyInImageData}) {

	return declare(LightGalleryController, {
		/**
		 * @override
		 * Return all images of node in property view and index of selected image
		 */
		_getImages() {
			const {currentImageKey, imageStore} = this.widget;
			const images = Array.from(imageStore.query());
			const index = getIndexOfKeyInImageData(images, currentImageKey);
			return [images, index];
		}
	});
});
